import { avatarUrl } from './pixel';

export default function Avatar({ agent, size = '' }) {
  if (!agent) return null;
  return <img className={`av ${size}`} src={avatarUrl(agent)} alt="" />;
}
